import { ulid } from 'ulid'

export const adAssetUploadReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.ADD_FILE: {
            const fileExists = state.files.some((file) => file.id === action.payload.id)
            if (fileExists) return state

            return {
                ...state,
                files: [action.payload, ...state.files],
            }
        }

        case ACTIONS.REMOVE_FILE:
            return {
                ...state,
                files: state.files.filter((f) => f.id !== action.payload.fileId),
            }

        case ACTIONS.UPDATE_FILE: {
            const { fileId: updateFileId, ...rest } = action.payload
            return {
                ...state,
                files: state.files.map((file) => (file.id === updateFileId ? { ...file, ...rest } : file)),
            }
        }

        case ACTIONS.UPDATE_ID: {
            const { oldId, newId } = action.payload
            return {
                ...state,
                files: state.files.map((file) => (file.id === oldId ? { ...file, id: newId } : file)),
            }
        }

        default:
            return state
    }
}

export const FILE_STATES = {
    INITIAL: 'initial',
    UPLOADING: 'uploading',
    UPLOADED: 'uploaded',
    STARTING_UPLOAD: 'starting_upload',
}

export const initialState = {
    uploadId: ulid(),
    files: [],
    uploadProgress: {},
    uploadedFiles: [],
    errors: {},
    status: 'initial',
}

export const ACTIONS = {
    ADD_FILE: 'ADD_FILE',
    REMOVE_FILE: 'REMOVE_FILE',
    UPDATE_FILE: 'UPDATE_FILE',
    UPDATE_ID: 'UPDATE_ID',
}
